<script setup>
import { ref } from 'vue';
import Dialog from 'dashboard/components-next/dialog/Dialog.vue';

const emit = defineEmits(['create-blank', 'create-template']);

const dialogRef = ref(null);

const open = () => {
  dialogRef.value?.open();
};

const close = () => {
  dialogRef.value?.close();
};

defineExpose({ open, close });
</script>

<template>
  <Dialog
    ref="dialogRef"
    title="Criar Novo Pipeline"
    :show-confirm-button="false"
    :show-cancel-button="false"
    width="md"
  >
    <div class="space-y-3">
      <!-- Opção: Do Zero -->
      <button
        class="w-full p-4 text-left border border-n-weak rounded-lg hover:border-n-brand hover:bg-n-alpha-1 transition-colors group"
        @click="emit('create-blank')"
      >
        <div class="flex items-start gap-3">
          <div class="flex-shrink-0 w-10 h-10 rounded-lg bg-n-blue-3 flex items-center justify-center group-hover:bg-n-blue-4 transition-colors">
            <span class="i-lucide-pencil text-lg text-n-blue-11" />
          </div>
          <div class="flex-1">
            <h4 class="text-sm font-bold text-n-slate-12 mb-1">
              Criar do Zero
            </h4>
            <p class="text-xs text-n-slate-11">
              Crie um pipeline personalizado com suas proprias etapas
            </p>
          </div>
        </div>
      </button>

      <!-- Opção: Templates -->
      <button
        class="w-full p-4 text-left border border-n-weak rounded-lg hover:border-n-brand hover:bg-n-alpha-1 transition-colors group"
        @click="emit('create-template')"
      >
        <div class="flex items-start gap-3">
          <div class="flex-shrink-0 w-10 h-10 rounded-lg bg-n-violet-3 flex items-center justify-center group-hover:bg-n-violet-4 transition-colors">
            <span class="i-lucide-layout-template text-lg text-n-violet-11" />
          </div>
          <div class="flex-1">
            <h4 class="text-sm font-bold text-n-slate-12 mb-1">
              Usar Template
            </h4>
            <p class="text-xs text-n-slate-11">
              Comece com um modelo pronto e personalize depois
            </p>
          </div>
        </div>
      </button>
    </div>
  </Dialog>
</template>
